import { BASE_URL } from "../../Environment/config"
import { httpClient } from "../../Http/client";

export const submitNewPassword = async (password, passwordConfirm, token) => {
    const url = `${BASE_URL}/reset-password`;
    
    const data = {
        password: password,
        passwordConfirm: passwordConfirm,
        token: token,
        role: "CUSTOMER"
    };

    const { data: resetData } = await httpClient.post(url, data);
    return resetData;
}
